module.exports = __webpack_public_path__ + "img/logo.d7557277.svg";